<div class="steps_list clrfx">
  <a [ngClass]="[currentStep == 1 ? 'active' : '']" (click)="goToStep(1, false)"><span>1</span></a>
  <a [ngClass]="[currentStep == 2 ? 'active' : '']" (click)="goToStep(2, false)"><span>2</span></a>
  <a [ngClass]="[currentStep == 3 ? 'active' : '']" (click)="goToStep(3, false)"><span>3</span></a>
  <a [ngClass]="[currentStep == 4 ? 'active' : '']" (click)="goToStep(4, false)"><span>4</span></a>
</div>

<div *ngIf="currentStep == 1" class="page_name">{{ 'Pages.AddOffer.Step1Name' | translate }}</div>
<div *ngIf="currentStep == 2" class="page_name">{{ 'Pages.AddOffer.Step2Name' | translate }}</div>
<div *ngIf="currentStep == 3" class="page_name">{{ 'Pages.AddOffer.Step3Name' | translate }}</div>
<div *ngIf="currentStep == 4 && !saveDraft" class="page_name">
  {{ 'Pages.AddOffer.Step4Name' | translate }}
</div>
<div *ngIf="currentStep == 4 && saveDraft" class="page_name">
  {{ 'Pages.AddOffer.Step4DraftName' | translate }}
</div>


<div class="step" id="step1" *ngIf="currentStep == 1">
  <div class="space_content big_radius static_shadow">
    <div class="form_class">
      <form [formGroup]="redactorForm1">

        <ng-container *ngIf="offer">

          <div class="liner">
            <div class="ttl_form">
              {{ 'Pages.AddOffer.HeadOfferType' | translate }}
              <a class="info_text" (click)="showInfoOfferType()"></a>
            </div>

            <div class="select-container add-offer">
              <mat-form-field appearance="standard">
                <mat-label>
                  {{ 'Pages.AddOffer.HeadOfferType' | translate }} <span>*</span>
                </mat-label>
                <mat-select [(value)]="offer.typeId">
                  <mat-option *ngFor="let offerType of offerTypes"
                              (click)="changeOfferType(offerType.value)"
                              [value]="offerType.value">
                    {{ offerType.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="offer.typeId === settings.nornickelOffer_OfferKindId" class="tabs active">
            <b style="font-weight: 500">{{ 'Pages.AddOffer.OfferText' | translate }}</b>
            {{ 'Pages.AddOffer.InfoOfferTypeText' | translate }}
            <br />
            <br />
            {{ 'Pages.AddOffer.InfoOfferTypeText2' | translate }}
          </div>

          <div *ngIf="offer.typeId === settings.nornickelProblem_OfferKindId">
            <b style="font-weight: 500">{{ 'Pages.AddOffer.Problem' | translate }}</b>
            {{ 'Pages.AddOffer.InfoProblemTypeText' | translate }}
          </div>

          <div *ngIf="offer.typeId === settings.nornickelStepForward_OfferKindId">
            <b style="font-weight: 500">{{ 'Pages.AddOffer.StepForward' | translate }}</b>
            {{ 'Pages.AddOffer.InfoStepForwardTypeText' | translate }}
          </div>

          <div class="button_block clrfx">
            <a (click)="goToStep(2, false)" class="button small_radius w100 bg_control_blue">
              {{
              isEditOffer
              ? ('Pages.AddOffer.EditOffer' | translate)
              : ('Pages.AddOffer.CreateOffer' | translate)
              }}
            </a>
            <a (click)="close()" class="save_and_close_idea button small_radius w100">
              {{ 'Pages.AddOffer.Close' | translate }}
            </a>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>

<div class="step" id="step2" *ngIf="currentStep == 2 && offer?.typeId">
  <div class="space_content big_radius static_shadow">
    <div class="form_class">
      <form [formGroup]="redactorForm2">
        <div class="liner">
          
          <div class="liner">
            <div class="ttl_form">
              {{ 'Pages.AddOffer.HeadOfferType' | translate }}
              <a class="info_text" (click)="showInfoOfferType()"></a>
            </div>

            <div class="select-container add-offer">
              <mat-form-field appearance="standard">
                <mat-label>
                  {{ 'Pages.AddOffer.HeadOfferType' | translate }} <span>*</span>
                </mat-label>
                <mat-select [(value)]="offer.typeId">
                  <mat-option *ngFor="let offerType of offerTypes"
                              (click)="changeOfferType(offerType.value)"
                              [value]="offerType.value">
                    {{ offerType.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="ttl_form">{{ 'Pages.AddOffer.HeadOfferDescription' | translate }}</div>

          <ng-container *ngIf="offer.typeId == settings.nornickelOffer_OfferKindId">
            <div class="list_tabs info_idea type_desc">

              <div [ngClass]="[isEdit ? 'ins_space top' : 'ins_space']">
                <div class="label">{{ 'Pages.AddOffer.FieldName' | translate }} <span>*</span></div>
                <input type="text" formControlName="name" />
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">
                  {{ 'Pages.AddOffer.FieldProblem' | translate }} <span>*</span>
                </div>
                <textarea formControlName="problem"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">{{ 'Pages.AddOffer.FieldReason' | translate }} <span>*</span></div>
                <textarea formControlName="reason"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">
                  {{ 'Pages.AddOffer.FieldSolution' | translate }} <span>*</span>
                </div>
                <textarea formControlName="solution"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">{{ 'Pages.AddOffer.FieldResult' | translate }} <span>*</span></div>
                <textarea formControlName="result"></textarea>
              </div>

              <div class="liner">
                <div>
                  <b style="font-weight: 500">
                    {{ 'Pages.AddOffer.FieldChooseOfferLine' | translate }}
                  </b>
                </div>

                <div class="changer taber clrfx change_vis">
                  <ul>
                    <li *ngFor="let offerLine of offerLines"
                        [ngClass]="[this.offer.hasEconomicEffect === offerLine.value ? 'active' : '']">
                      <a (click)="changeEconomicEffect(offerLine.value)">
                        {{ offerLine.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">{{ 'Pages.AddOffer.FieldComment' | translate }}</div>
                <textarea formControlName="comment"></textarea>
              </div>

              <div>
                <label class="checkbox">
                  <input type="checkbox"
                         formControlName="agreeWithSuggestionsPolicy"
                         name="agreeWithSuggestionsPolicy" />
                  <div class="checkbox__text">
                    {{ 'Pages.AddOffer.FieldAgreeWithSuggestionsPolicy' | translate }}
                    <span class="red">*</span>
                  </div>
                </label>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="offer.typeId == settings.nornickelProblem_OfferKindId">
            <div class="list_tabs info_idea type_desc">

              <div [ngClass]="[isEdit ? 'ins_space top' : 'ins_space']">
                <div class="label">{{ 'Pages.AddOffer.FieldName' | translate }} <span>*</span></div>
                <input type="text" formControlName="name" />
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">
                  {{ 'Pages.AddOffer.FieldProblem' | translate }} <span>*</span>
                </div>
                <textarea formControlName="problem"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">
                  {{ 'Pages.AddOffer.FieldSolution' | translate }} <span>*</span>
                </div>
                <textarea formControlName="solution"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">{{ 'Pages.AddOffer.FieldOutlay' | translate }}</div>
                <textarea formControlName="outlay"></textarea>
              </div>

              <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
                <div class="label">{{ 'Pages.AddOffer.FieldComment' | translate }}</div>
                <textarea formControlName="comment"></textarea>
              </div>

            </div>
          </ng-container>

          <ng-container *ngIf="offer.typeId == settings.nornickelStepForward_OfferKindId">

            <div [ngClass]="[isEdit ? 'ins_space top' : 'ins_space']">
              <div class="label">{{ 'Pages.AddOffer.OfferKind_StepForward.FieldName' | translate }} <span>*</span></div>
              <input type="text" formControlName="name" />
            </div>

            <div [ngClass]="[isEdit ? 'ins_space textarea top' : 'ins_space textarea']">
              <div class="label">
                {{ 'Pages.AddOffer.OfferKind_StepForward.FieldProblem' | translate }} <span>*</span>
              </div>
              <textarea formControlName="problem"></textarea>
            </div>

            <div class="datepicker-container">
              <mat-form-field appearance="standard">
                <mat-label>
                  {{ 'Pages.AddOffer.OfferKind_StepForward.FieldData1' | translate }} <span>*</span>
                </mat-label>
                <input matInput
                       [matDatepicker]="picker"
                       placeholder="{{ 'Common.ChooseDate' | translate }}"
                       formControlName="data1">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

          </ng-container>

        </div>
      </form>
    </div>

    <div class="button_block clrfx">
      <a (click)="goToStep(3, false)" class="button small_radius w100 bg_control_blue">
        {{ 'Pages.AddOffer.NextStep' | translate }}
      </a>
      <a (click)="close()" class="save_and_close_idea button small_radius w100">
        {{ 'Pages.AddOffer.Close' | translate }}
      </a>
    </div>
  </div>
</div>

<div class="step" id="step3" *ngIf="currentStep == 3">
  <div class="space_content big_radius static_shadow">
    <div class="form_class">
      <form [formGroup]="redactorForm3">


        <ng-container *ngIf="offer.typeId == settings.nornickelOffer_OfferKindId || offer.typeId == settings.nornickelProblem_OfferKindId">
          <div class="liner">
            <div class="ttl_form">
              {{ 'Pages.AddOffer.HeadHiddenPublished' | translate }}
              <a class="info_text" (click)="showInfoHiddenPublished()"></a>
            </div>
            <div class="changer taber clrfx change_vis">
              <ul>
                <li [ngClass]="[!offer.hiddenPublished ? 'active' : '']">
                  <a (click)="offer.hiddenPublished = false">
                    {{ 'Pages.AddOffer.NotHiddenPublished' | translate }}
                  </a>
                </li>
                <li [ngClass]="[offer.hiddenPublished ? 'active' : '']">
                  <a (click)="offer.hiddenPublished = true">
                    {{ 'Pages.AddOffer.HiddenPublished' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="liner">
            <app-file-selector viewType="imageList"
                               headerText="{{ 'Pages.AddOffer.HeadPhoto' | translate }}"
                               deleteButtonText="{{ 'Pages.AddOffer.DeleteButton' | translate }}"
                               [allowFileExtensions]="settings.allowedImageTypesToUpload"
                               [maxFileSize]="settings.maxFileSize_kBytes"
                               [fileList]="offer.photosBeforeIntroduction">
            </app-file-selector>
          </div>

          <div class="liner">
            <app-file-selector viewType="fileNameList"
                               headerText="{{ 'Pages.AddOffer.AttachedFiles' | translate }}"
                               addButtonText="{{ 'Pages.AddOffer.AddButton' | translate }}"
                               [allowFileExtensions]="settings.allowedDocumentTypesToUpload"
                               [maxFileSize]="settings.maxFileSize_kBytes"
                               [fileList]="offer.photosAfterIntroduction">
            </app-file-selector>
          </div>
        </ng-container>


        <ng-container *ngIf="offer.typeId == settings.nornickelStepForward_OfferKindId">
          <div class="liner">
            <app-file-selector viewType="imageList"
                               headerText="{{ 'Pages.AddOffer.HeadPhoto_OfferKind_StepForward' | translate }}"
                               deleteButtonText="{{ 'Pages.AddOffer.DeleteButton' | translate }}"
                               maxFileCount="1"
                               [allowFileExtensions]="settings.allowedImageTypesToUpload"
                               [maxFileSize]="settings.maxFileSize_kBytes"
                               [fileList]="offer.photosBeforeIntroduction">
            </app-file-selector>
          </div>
        </ng-container>


        <div class="liner">
          <app-org-dep-div-selector #orgDepDivSelector
                                    headerText="{{ 'Pages.AddOffer.HeadImprovement' | translate }}"
                                    organizationHeaderText="{{ 'Pages.AddOffer.FieldOrganization' | translate }}"
                                    departmentHeaderText="{{ 'Pages.AddOffer.FieldDepartment' | translate }}"
                                    divisionHeaderText="{{ 'Pages.AddOffer.FieldDivision' | translate }}"
                                    userBlockHeaderText="{{ 'Pages.Offer.FieldBlock' | translate }}"
                                    [allOrganizations]="allOrganizations"
                                    [allDepartments]="allDepartments"
                                    [allDivisions]="allDivisions"
                                    [allUserBlocks]="allUserBlocks"
                                    [(selectedOrganizations)]="selectedOrganizations"
                                    [(selectedDepartments)]="selectedDepartments"
                                    [(selectedDivisions)]="selectedDivisions"
                                    [(selectedUserBlocks)]="selectedUserBlocks"
                                    (selectedOrganizationsChange)="selectedOrgChangeEvent($event)"
                                    (selectedDepartmentsChange)="selectedDepChangeEvent($event)"
                                    (selectedDivisionsChange)="selectedDivChangeEvent($event)"
                                    (selectedUserBlocksChange)="selectedUserBlockChangeEvent($event)">
          </app-org-dep-div-selector>
        </div>


        <ng-container *ngIf="offer.typeId == settings.nornickelOffer_OfferKindId">
          <div class="liner">
            <app-check-box-list headerText="{{ 'Pages.AddOffer.HeadLossType' | translate }}"
                                [allowMultipleSelection]="true"
                                [itemsSource]="allLossTypes"
                                [selectedItems]="selectedLossTypes"
                                [isRequired]="true"
                                (selectedItemsChange)="selectedLossTypesChangeEvent($event)">

            </app-check-box-list>
          </div>
        </ng-container>

        <ng-container *ngIf="offer.typeId == settings.nornickelProblem_OfferKindId">
          <div class="liner">
            <app-check-box-list headerText="{{ 'Pages.AddOffer.HeadRubric' | translate }}"
                                [allowMultipleSelection]="false"
                                [itemsSource]="allClassificators" 
                                [selectedItems]="selectedClassificators"
                                [isRequired]="true"
                                (selectedItemsChange)="selectedClassificatorsChangeEvent($event)">

            </app-check-box-list>
          </div>
        </ng-container>

        <!--Авторы-->
        <div class="liner">
          <app-offer-members headerText="{{ 'Pages.AddOffer.HeadAuthor' | translate }}"
                             searchMemberHeaderText="{{ 'Pages.AddOffer.SearchMembersTitle' | translate }}"
                             memberExistsErrorText="{{ 'Pages.AddOffer.AuthorExists' | translate }}"
                             addButtonText="{{ 'Pages.AddOffer.AddButton' | translate }}"
                             [isAuthors]="true"
                             [showPercentage]="true"
                             [allowEditPercentage]="offer.typeId == settings.nornickelOffer_OfferKindId || offer.typeId == settings.nornickelProblem_OfferKindId"
                             [allowEditMemberList]="false"
                             [(memberList)]="authorMemberList"
                             (memberListChange)="offerMemberListChangeEvent($event)">

          </app-offer-members>
        </div>

        <!--Соавторы-->
        <ng-container *ngIf="offer.typeId == settings.nornickelOffer_OfferKindId || offer.typeId == settings.nornickelProblem_OfferKindId">
          <div class="liner">
            <app-offer-members headerText="{{ 'Pages.AddOffer.HeadMembers' | translate }}"
                               searchMemberHeaderText="{{ 'Pages.AddOffer.SearchMembersTitle' | translate }}"
                               memberExistsErrorText="{{ 'Pages.AddOffer.AuthorExists' | translate }}"
                               addButtonText="{{ 'Pages.AddOffer.AddButton' | translate }}"
                               [isCoAuthors]="true"
                               [showPercentage]="true"
                               [allowEditPercentage]="true"
                               [allowEditMemberList]="true"
                               [(memberList)]="coAuthorMemberList"
                               (memberListChange)="offerMemberListChangeEvent($event)">

            </app-offer-members>
          </div>
        </ng-container>
      </form>
    </div>

    <div class="button_block clrfx">
      <a *ngIf="!offer.statusId"
         (click)="goToStep(4, false)"
         class="button small_radius w100 bg_control_blue">
        {{ 'Pages.AddOffer.Publish' | translate }}
      </a>
      <a *ngIf="offer.statusId"
         (click)="goToStep(4, true)"
         class="button small_radius w100 bg_control_blue">
        {{ 'Pages.AddOffer.SaveOffer' | translate }}
      </a>
      <a (click)="goToStep(2, false)" class="button small_radius w100 border_blue">
        {{ 'Pages.AddOffer.Back' | translate }}
      </a>
      <a (click)="close()" class="save_and_close_idea button small_radius w100">
        {{ 'Pages.AddOffer.Close' | translate }}
      </a>
    </div>
  </div>
</div>

<div class="step" id="step4" *ngIf="currentStep == 4">
  <div class="space_content big_radius static_shadow">
    <div class="ico_thanks"></div>
    <div class="text_thanks" *ngIf="!saveDraft">
      {{ 'Pages.AddOffer.Congratulations1' | translate }}
      <br />
      {{ 'Pages.AddOffer.Congratulations2' | translate }}
    </div>
    <div class="text_thanks" *ngIf="saveDraft">
      {{ 'Pages.AddOffer.CongratulationsDraft1' | translate }}
      <br />
      {{ 'Pages.AddOffer.CongratulationsDraft2' | translate }}
    </div>

    <div class="button_block clrfx">
      <a routerLink="/" class="button small_radius w100 bg_control_blue">
        {{ 'Pages.AddOffer.ReturnToMain' | translate }}
      </a>
    </div>
  </div>
</div>
